/*HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

export const routeBase = "/";
export const routeRoot = "/";
export const routeUntrost = "/inicio"
export const routeLogin = "/login";
export const routeMain = "/leyout";
export const routeLanding = "/Landing";
export const routeDashboard = "/*";
export const routeCalibracion = "/MEN045";
export const routeCargaCalibracion = "/MEN046";
export const routeUsuarios = "/MEN030/*";
export const routeRoles = "/roles/*";
export const routeTrabajador = "/MEN010";
export const routeAccessControl = "/MEN029";

export const API_URL_BASE = process.env.REACT_APP_URL_BASE || "http://localhost:3001";

